/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Table } from 'rsuite';
import { DataTableMenuBtn } from 'types';
import styles from './ViewContactLogCell.module.scss';

interface IViewContactLogCellProps {
  menuBtn?: DataTableMenuBtn;
}

const { Cell } = Table;

function ViewContactLogCell({
  rowData,
  menuBtn = undefined,
  ...props
}: any & IViewContactLogCellProps) {
  if (menuBtn) {
    const { label, logView } = menuBtn;

    return (
      <Cell {...props}>
        <div className={styles.cell}>
          <button
            type="button"
            className={styles.btn}
            onClick={() => logView(rowData)}
          >
            <p>{label} </p>
          </button>
        </div>
      </Cell>
    );
  }

  return (
    <Cell {...props}>
      <div className={styles.cell}>
        <p>View Log </p>
      </div>
    </Cell>
  );
}

export default ViewContactLogCell;
